<template>
  <div class="eddy-levitation-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>楞次定律 + 感应涡流</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Solenoid (Coil) -->
          <g transform="translate(150, 180)">
             <rect width="100" height="40" fill="#333" stroke="#ffd700" stroke-width="2" />
             <text x="30" y="60" fill="#ffd700" font-size="8">交流线圈 (AC)</text>
             <path v-for="i in 5" :key="i" :d="`M ${i*20 - 5}, -10 Q ${i*20}, -50 ${i*20 + 5}, -10`" fill="none" stroke="#ffd700" opacity="0.4">
                <animate attributeName="opacity" values="0.1;0.6;0.1" dur="0.2s" repeatCount="indefinite" />
             </path>
          </g>

          <!-- The Leviting Plate (Aluminum) -->
          <g :transform="`translate(160, ${150 - current*0.8})`">
             <rect width="80" height="8" fill="#aaa" stroke="#fff" rx="2" />
             <!-- Jitter animation -->
             <animateTransform attributeName="transform" type="translate" :values="`160,${150 - current*0.8}; 160,${150 - current*0.8 + 2}; 160,${150 - current*0.8}`" dur="0.1s" repeatCount="indefinite" />
             
             <!-- Eddy current spirals -->
             <circle cx="20" cy="4" r="10" fill="none" stroke="#ffd700" stroke-width="1" opacity="0.4" />
             <circle cx="60" cy="4" r="10" fill="none" stroke="#ffd700" stroke-width="1" opacity="0.4" />
          </g>

          <!-- Magnetic field lines (Conceptual) -->
          <path v-for="i in 3" :key="'f'+i" :d="`M 170,180 Q ${120-i*20},100 170,20`" fill="none" stroke="rgba(255,255,255,0.05)" />
          <path v-for="i in 3" :key="'g'+i" :d="`M 230,180 Q ${280+i*20},100 230,20`" fill="none" stroke="rgba(255,255,255,0.05)" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>悬浮高度: {{ (current*0.8).toFixed(0) }} mm</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>交流电流 I_ac</label>
             <el-slider v-model="current" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当一个导体（如铝板）放置在交流磁场中时，其内部会产生不断变化的**涡电流**。根据楞次定律，这些感应电流产生的磁场总是反抗原磁场的变化。虽然交流电在方向上不断切换，但由相互排斥产生的**平均上向力**可以抵消重力，使导体稳定悬浮在空气中。这是工业金属熔炼无容器加工的基础。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EddyLevitationViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      current: 50
    }
  }
}
</script>

<style scoped lang="scss">
.eddy-levitation-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
